import React, { VoidFunctionComponent } from "react";
import {ProductDocumentList} from "@/models/scope/productSheet/ProductDocumentList";


export const EnergyClass: VoidFunctionComponent<{
    isNewEnergyClass?: boolean,
    energyClass: string,
    documentId: ProductDocumentList<string> | null,
}> = ({isNewEnergyClass = false, energyClass, documentId}) => {
    let pictoClassNameList = {};
    if(isNewEnergyClass){
        pictoClassNameList = {'A': 'A', 'B': 'B', 'C': 'C', 'D': 'D', 'E': 'E', 'F': 'F', 'G': 'G'};
    } else {
        pictoClassNameList = {'A+++': 'A', 'A++': 'B', 'A+': 'C', 'A': 'D', 'B': 'E', 'C': 'F', 'D': 'G'};
    }
    let note = Object.entries(pictoClassNameList).find(([key, value]) =>  energyClass === key);
    note = note ? note : [energyClass, ''];
    const energyDocumentCodes = ["_E", "_E2010", "_E2019"];
    const activeDocumentCode = energyDocumentCodes.find((key) => documentId && documentId[key]);
    const renderEnergyClass = () => (
        note && (<div className={`picto-energie niv${note[1]}`}>
            {isNewEnergyClass && <div className="icon"/>}
            <p id="gtm-energyClass-value" className="note">{note[0]}</p>
        </div>)
    );
    return (
        <>
            {documentId && activeDocumentCode ? (
                <a
                    className='link'
                    href={documentId[activeDocumentCode]}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    {energyClass && note && renderEnergyClass()}
                </a>
            ) : energyClass && note && renderEnergyClass()}
        </>
    );
}